import React, { FC, HTMLAttributes } from 'react'
import classNames from 'classnames'
import { HeartIcon } from '@/atoms/Icons/HeartIcon'
import { IconSwitch } from '@/atoms/Switch/IconSwitch'
import { VideoReactionButton } from '@/molecules/VideoReactionButton'
import { useCollectiblesPlayer } from '@/organisms/CollectiblesPlayer/CollectiblesPlayerContext'

interface FavoriteASceneProps extends HTMLAttributes<HTMLElement> {
  onUserReaction?: () => void
}

export const FavoriteAScene: FC<FavoriteASceneProps> = ({ className, onUserReaction }) => {
  const { isShowingReactionButton, toggleShowReactionButton } = useCollectiblesPlayer()

  const handleShowReactionChange = () => {
    toggleShowReactionButton?.()
  }

  const heartColor = isShowingReactionButton ? 'oxide-bright' : 'gray-300'
  const knobClassName = isShowingReactionButton ? 'bg-white' : 'bg-gray-800'
  const switchClassName = isShowingReactionButton
    ? 'bg-oxide-bright border border-solid border-4 border-oxide/[.4]'
    : 'border-0 bg-gray-300/[.4]'

  return (
    <div className={classNames(className, 'flex items-center justify-end h-14 space-x-5')}>
      {isShowingReactionButton && <VideoReactionButton onClick={onUserReaction} />}
      <IconSwitch
        knobClassName={classNames('w-10 h-10', knobClassName)}
        switchClassName={switchClassName}
        checked={isShowingReactionButton}
        onChange={handleShowReactionChange}
      >
        <HeartIcon size={20} color1={heartColor} color2={heartColor} />
      </IconSwitch>
    </div>
  )
}
